import React from 'react';
import {useWindowSize, FacebookIcon, InstagramIcon, YouTubeIcon} from '../../../../../general';
import {useTranslation} from '../../../../../general/i18n/Translations';

export const FooterLinks = () => {
    const {locale} = useTranslation();
    const showFullInfo = locale !== 'ro';

    return (
        <div className={'mt-[60px] w-full flex flex-col items-center justify-center'}>
            <div className="flex flex-row gap-10">
                <a
                    href="https://www.youtube.com/channel/UCsd3G7ddoNQGIYjm8tc_BXQ"
                    title="Youtube"
                >
                    <YouTubeIcon size={'w-10 h-10'}/>
                </a>
                <a
                    href="https://www.facebook.com/MagaziaLuCostica"
                    title="Facebook"
                >
                    <FacebookIcon size={'w-10 h-10'}/>
                </a>
                <a
                    href="https://www.instagram.com/magazialucostica/"
                    title="Instagram"
                >
                    <InstagramIcon size={'w-10 h-10'}/>
                </a>
            </div>
            <div className={'mt-[60px] mb-5 text-text-gray font-montserratm text-center'}>
                {showFullInfo ? (
                    <div className={'flex flex-col gap-2'}>
                        <div>{'©'} {new Date().getFullYear()} - Keiron Logistics s.r.l. All rights reserved</div>
                        <div className={'text-sm'}>
                            Keiron Logistics s.r.l. | Street Strandului no.70, 100189 city: Ploiesti | costica@magazialucostica.ro | www.magazialucostica.ro | VAT no.: RO 6697285
                        </div>
                    </div>
                ) : (
                    <div>{'©'} {new Date().getFullYear()} - Keiron Logistics</div>
                )}
            </div>
        </div>
    );
};